<template>
    <div>
      <div class="web-only landing">
        <div
          class="row web-only"
          style="
            color: #1f4e78;
            padding-top: 60px;
            padding-bottom: 60px;
            padding-left: 7%;
            padding-right: 7%;
            width: 100%;
            background-color: white;
            margin-left: 0;
          "
        >
          <div class="col-lg-6 col-md-6 px-3" style="margin-top: auto; margin-bottom: auto;">
            <!-- <h1 style="font-weight: 900; margin-bottom: 8px;">The software platform</h1> -->
            <h1 style="font-weight: 900; margin-bottom: 12px; font-size: 2rem;">
                The #1 app for medical staffing agency management
            </h1>
            <!-- <div class="web-only">
              <h3 style="margin-bottom: 4px;">Run your agency smarter with a software solution designed just for you. Your clients and candidates will love it.</h3>
            </div> -->
            <!-- <p style="font-size: 1.25rem; margin-top: 15px; margin-bottom: 2px;">Custom application forms, scheduling, payments, documents, email+SMS automation, beautiful candidate profiles, powerful client dashboards, jobs, bookings, video, interviews, references, analytics - all in one.</p> -->
            <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 25px;
                margin-bottom: 25px;
              ">
              From the moment a medical professional arrives on your website to the moment you get paid, and everything in between, power your agency with the truly all-in-one platform that takes care of your entire process. 
            </h2>
            <!-- <h2 style="
                font-size: 1.25rem;
                line-height: 1.35;
                margin-top: 5px;
                margin-bottom: 35px;
              ">
              Dentists, Hygienists, Assistants, Front Desk and More
            </h2> -->

            <!-- maternity nurse https://www.instagram.com/nannyskye/ -->

            <!-- <p style="font-size: 1.2rem; margin-bottom: 2px;">Offer candidates and clients a seamless experience and</p> -->
            <!-- <p style="font-size: 1.2rem;" class="mb-5">establish your brand as the go to for your niche.</p> -->
  
            <!-- <div class="mt-5">
              <router-link
                :to="{ name: 'Get Started' }"
                class="mylisting-button light-button"
              >Get Started</router-link>
              <router-link
                :to="{ name: 'Book Demo' }"
                class="mylisting-button light-button"
              >Learn More</router-link>
            </div> -->

            <!-- <a class="mylisting-button dark-button" href="https://myportfolio.enginehire.io/candidates/KPMxBg2oVL1WAQwy" target="_blank">Check Out An Example</a> -->
          </div>
          <div
            class="col-lg-6 col-md-6 web-only px-3"
            style=""
          >
            <img
              src="../assets/img/mobileapp/mobile hero dental.svg"
              width="100%"
              height=""
              class=""
            />
  
            <!-- <transition
              name="message"
              mode="out-in"
            >
              <template v-for="(message, index) of listMessages">
                <div
                  :key="'message-' + index"
                  class=""
                  v-if="messageCount === index + 1"
                >
                  <img
                    :src="
                      require(`../assets/img/home/${message.img}`)
                    "
                    width=""
                    height=""
                    class=""
                  />
                </div>
              </template>
            </transition> -->
          </div>
        </div>
      </div>
  
      <div class="mobile-only mobile-landing">
        <div
          class=""
          style="
            color: #1f4e78;
            padding-top: 6vh;
            padding-bottom: 0px;
            padding-left: 5%;
            padding-right: 5%;
            width: 100%;
            background-color: white;
          "
        >
          <!-- <h1 style="font-weight: 900; margin-bottom: 8px;">The software platform</h1> -->
          <h1
            style="font-weight: 900; margin-bottom: 15px"
            class="center"
          >
            The #1 app <br>for medical staffing <br>agency management
          </h1>
          <div class="">
            <h4
              style="margin-bottom: 30px; line-height: 1.35"
              class="center"
            >
              From the moment a medical professional arrives on your website to the moment you get paid, and everything in between, power your agency with the truly all-in-one platform that takes care of your entire process. 
            </h4>
            <!-- <h3>solo and small staffing operations.</h3> -->
          </div>

          <!-- <div class="center" style="margin-top: 30px; margin-bottom: 30px;">
            <a class="mylisting-button dark-button" href="https://myportfolio.enginehire.io/candidates/KPMxBg2oVL1WAQwy" target="_blank">Check Out An Example</a>
          </div> -->

          <!-- <img
                src="../assets/img/home/AdobeStock_601258960_cropped.jpg"
                width="90%"
                height=""
                class="my-auto pt-4 center"
            /> -->
        <img
              src="../assets/img/mobileapp/mobile hero dental.svg"
              width="100%"
              height=""
              class="center mt-4 mb-4"
            />

          <!-- <h4
              style="padding-bottom: 40px; line-height: 1.35"
              class="center"
            >
              Dentists, Hygienists, Assistants, Front Desk and More
            </h4> -->

          <!-- <p style="margin-bottom: 2px;" class="center">Custom application forms, scheduling, payments, documents, email+SMS automation, beautiful candidate profiles, powerful client dashboards, jobs, bookings, video, interviews, references, analytics - all in one.</p> -->
          <!-- <p style="font-size: 1.2rem; margin-bottom: 2px;">Offer candidates and clients a seamless experience and</p> -->
          <!-- <p style="font-size: 1.2rem;" class="mb-5">establish your brand as the go to for your niche.</p> -->
        </div>
      </div>

      <div class="web-only" style="padding-left: 7%; padding-right: 7%; padding-top: 5%; padding-bottom: 6%; background-color: var(--bootstrapgrey);">
        <div
              class="card p-5 mb-3"
              style="text-align: left;"
            >
              <!-- <h2>The adults at your event will be able to truly engage, knowing their kids are in good hands!</h2> -->
              <h4 class="" style="font-weight: 800;">We'll start by working with you to create a customized client booking and registration form</h4>
              <!-- <h5><i>Did You Know</i></h5> -->
              <!-- <div class="card-body"> -->
                <!-- <h3
                  style="font-weight: 600; line-height: 1.25;"
                  class="mt-2 mb-3"
                >Families are 2.8x more likely to interview a caregiver after watching a video of them</h3>
                <h5 class="card-text">Families want to know who you are! Not just a piece of paper telling them what you've done.</h5> -->
              
                
              <!-- </div> -->

              <div class="row">
                <div class="col-lg-6">
                  <!-- <ul>
                    <li>We've seen agencies need 5 key things: parents' info, kids' info, booking dates and times, payment info, and a signed agreement. </li>
                    <li>If you have these 5 things, you can immediately match a family with a caregiver without chasing them for anything!</li>
                    <li>This form is embedded directly into your website, making it as easy as possible for new clients, no need to download anything</li>
                  </ul> -->
                    <!-- <h5 class="mt-4" style="font-weight: 900; ">Step 1</h5> -->
                    <h4 style="margin-bottom: 10px; margin-top: 20px;">Agencies need 5 key things from new clients: 
                      <!-- parents' info, kids' info, booking dates and times, payment info, and a signed agreement. -->
                    </h4>
                    <h4>
                      <ul>
                        <li>1. Contact Info</li><br>
                        <li>2. Intitution Info</li><br>
                        <li>3. Service Type, Dates & Times</li><br>
                        <li>4. Payment Info</li><br>
                        <li>5. Signed Agreement</li>
                      </ul>
                    </h4>
                    <h5 style="margin-bottom: 25px; line-height: 1.5;">If you have these 5 things, you can immediately match an office with on of your medical professionals without chasing them for anything!</h5>
                    
                    <!-- <h5 class="mt-3" style="line-height: 1.5; margin-bottom: 35px;">This can be split into steps too, gather basic info from applicants initially, and if they seem good send them a follow up form to collect the rest.</h5> -->
                    <a class="mylisting-button dark-button" href="https://dentaldemo.enginehire.io/application-form/169/3500?selector3=On%20call%20service" target="_blank">See An Example</a>

                    <h5 style="margin-bottom: 25px; margin-top: 35px; line-height: 1.5;">This form is embedded directly into your website, making it as easy as possible for new clients, no need to download anything.</h5>
                    <h4 style="margin-bottom: 25px; font-weight: 800;">Once they register every client has an app account where they can make and manage their bookings</h4>
                    <h5 style="margin-bottom: 25px; line-height: 1.5;">No more last minute emails, calls and texts to change from 9am to 8am! Automated cancellation fees.</h5>

                    <!-- <h5 class="" style="font-weight: 900; margin-top: 75px;">Step 2</h5>
                    <h4>We work with you to design a beautiful portfolio. We can recreate a design you have existing, or you can customize from our template library!</h4>
                    <h5 class="mt-3" style="line-height: 1.5; margin-bottom: 35px;">The magical part is as applicants fill in your forms in step 1, it will auto clean up, format and lay everything out into your design. No more time spent in Word or Canva!</h5> -->

                    <!-- <h5 class="" style="font-weight: 900; margin-top: 75px;">Step 3</h5>
                    <h4>Add all kinds of incredible touches like video introductions, image galleries, custom badges and more!</h4>
                    <div class="" style="margin-top: 35px;">
                        <router-link
                        :to="{ name: 'Book Demo Portfolio Manager' }"
                        class="mylisting-button dark-button"
                        >Learn More</router-link>
                    </div> -->
                </div>
                <div class="col-lg-6 py-3 px-3">
                    <img
                      src="../assets/img/mobileapp/client side dental2.svg"
                      alt=""
                      class="px-4 pt-4"
                      style="width: 100%; margin-top: auto; margin-bottom: auto;"
                    >
                </div>
              </div>
            </div>
      </div>

      <div class="mobile-only" style="padding-left: 7%; padding-right: 7%; padding-top: 7%; padding-bottom: 6%; background-color: var(--bootstrapgrey);">
        <div
              class="card p-4 mb-3"
              style="text-align: left;"
            >
              <h4 class="" style="font-weight: 800;">We'll start by working with you to create a customized client booking and registration form</h4>

              <div class="row">
                <div class="col-lg-6">
                  <!-- <ul>
                    <li>We've seen agencies need 5 key things: parents' info, kids' info, booking dates and times, payment info, and a signed agreement. </li>
                    <li>If you have these 5 things, you can immediately match a family with a caregiver without chasing them for anything!</li>
                    <li>This form is embedded directly into your website, making it as easy as possible for new clients, no need to download anything</li>
                  </ul> -->
                    <!-- <h5 class="mt-4" style="font-weight: 900; ">Step 1</h5> -->
                    <h4 style="margin-bottom: 10px; margin-top: 20px;">Agencies need 5 key things from new clients: 
                      <!-- parents' info, kids' info, booking dates and times, payment info, and a signed agreement. -->
                    </h4>
                    <h4>
                      <ul>
                        <li>1. Contact Info</li><br>
                        <li>2. Institution Info</li><br>
                        <li>3. Service Type, Dates & Times</li><br>
                        <li>4. Payment Info</li><br>
                        <li>5. Signed Agreement</li>
                      </ul>
                    </h4>
                    <h5 style="margin-bottom: 35px; line-height: 1.5;">If you have these 5 things, you can immediately match an office with on of your medical professionals without chasing them for anything!</h5>
                    
                    <!-- <h5 class="mt-3" style="line-height: 1.5; margin-bottom: 35px;">This can be split into steps too, gather basic info from applicants initially, and if they seem good send them a follow up form to collect the rest.</h5> -->
                    <a class="mylisting-button dark-button" href="https://dentaldemo.enginehire.io/application-form/169/3500?selector3=On%20call%20service" target="_blank">See An Example</a>

                    <!-- <h5 style="margin-bottom: 25px; margin-top: 35px; line-height: 1.5;">This form is embedded directly into your website, making it as easy as possible for new clients, no need to download anything.</h5> -->
                    <h4 style="margin-bottom: 25px; margin-top: 35px; font-weight: 800;">Once they register every client has an account where they can make and manage their bookings</h4>
                    <h5 style="margin-bottom: 25px; line-height: 1.5;">No more last minute emails, calls and texts to change from 9am to 8am! Automated cancellation fees.</h5>

                    <!-- <h5 class="" style="font-weight: 900; margin-top: 75px;">Step 2</h5>
                    <h4>We work with you to design a beautiful portfolio. We can recreate a design you have existing, or you can customize from our template library!</h4>
                    <h5 class="mt-3" style="line-height: 1.5; margin-bottom: 35px;">The magical part is as applicants fill in your forms in step 1, it will auto clean up, format and lay everything out into your design. No more time spent in Word or Canva!</h5> -->

                    <!-- <h5 class="" style="font-weight: 900; margin-top: 75px;">Step 3</h5>
                    <h4>Add all kinds of incredible touches like video introductions, image galleries, custom badges and more!</h4>
                    <div class="" style="margin-top: 35px;">
                        <router-link
                        :to="{ name: 'Book Demo Portfolio Manager' }"
                        class="mylisting-button dark-button"
                        >Learn More</router-link>
                    </div> -->
                </div>
                <div class="col-lg-6 py-3">
                    <img
                      src="../assets/img/mobileapp/client side dental2.svg"
                      alt=""
                      class="pt-2"
                      style="width: 100%; margin-top: auto; margin-bottom: auto;"
                    >
                </div>
              </div>
            </div>
      </div>

      <!-- <div
        class="web-only center px-2"
        style="
          background-color: var(--coredarkcolor);
          padding-top: 60px;
          padding-bottom: 70px;
        "
      >
        <h4 style="color: white; margin-bottom: 20px; font-weight: 800;">
          You can also sell subscriptions!
        </h4>

        <h5 style="color: white; margin-top: 24px">
          Like <span style="font-weight: 800;">"5 bookings/month for $120/month" which auto renews monthly</span> & customers can manage themselves.
        </h5>
        <h5 style="color: white; margin-top: 14px;">
          It is an incredible way to build sustainable, repeat customers and revenue.
        </h5>
        <h5 style="color: white; margin-top: 25px; margin-bottom: 35px;">
          <em>Zero added platform transaction fees for any of your payments!</em>
        </h5>
        <div class="mt-3" style="margin-bottom: 25px;">
          <router-link
            :to="{ name: 'Book App Demo' }"
            class="mylisting-button light-button mx-1"
          >Schedule a Demo</router-link>
        </div>
      </div> -->

      <!-- <div
        class="mobile-only center px-4"
        style="
          background-color: var(--coredarkcolor);
          padding-top: 60px;
          padding-bottom: 60px;
        "
      >
        <h4 style="color: white; margin-bottom: 20px; font-weight: 800;">
          You can also sell subscriptions!
        </h4>

        <h5 style="color: white; margin-top: 24px">
          Like <span style="font-weight: 800;">"5 bookings/month for $120/month" which auto renews monthly</span> & customers can manage themselves. It is an incredible way to build sustainable, repeat customers and revenue.
        </h5>
        <h5 style="color: white; margin-top: 25px; margin-bottom: 35px;">
          <em>Zero added platform transaction fees for any of your payments!</em>
        </h5>
        <div class="mt-3" style="margin-bottom: 25px;">
          <router-link
            :to="{ name: 'Book App Demo' }"
            class="mylisting-button light-button mx-1"
          >Schedule a Demo</router-link>
        </div>
      </div> -->

      <div class="web-only">
        <div
          class="row"
          style="margin-right: 0;"
        >
          <div
            class="col-lg-6"
            style="margin-right: 0; padding: 0;"
          >
            <div class="mapimage">

            </div>
          </div>
          <div
            class="col-lg-6"
            style="padding-left: 7%; padding-right: 7%; padding-top: 6%; padding-bottom: 5%;"
          >
            <!-- <h2>
              Every booking comes into a beautiful, powerful master calendar for you and your admins
            </h2> -->
            <h1 style="font-weight: 900; margin-bottom: 12px; font-size: 2rem;">
                Every booking comes into a beautiful, powerful master calendar
            </h1>
            <!-- <h4 class="mt-4">Know exactly what's going on every day </h4> -->
            <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 25px;
                margin-bottom: 25px;
              ">
              You and your admin team will know exactly what's going on every day
            </h2>
            </div>
        </div>
      </div>

      <div class="mobile-only">
        <div
          class=""
          style="padding-left: 7%; padding-right: 7%; padding-top: 50px; padding-bottom: 5%;"
        >
          <!-- <h2>
            Every booking comes into a beautiful, powerful master calendar for you and your admins
          </h2> -->
          <h1 style="font-weight: 900; margin-bottom: 12px; font-size: 2rem;">
            Every booking comes into a beautiful, powerful master calendar
            </h1>
          <!-- <h4 class="mt-4" style="line-height: 1.3;">Know exactly what's going on every day </h4> -->
          <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 25px;
                margin-bottom: 25px;
              ">
              You and your admin team will know exactly what's going on every day
            </h2>
        </div>
        <img src="../assets/img/newborn/master_calendar crop.png" alt="" style="width: 100%;">
      </div>

      <div class="web-only">
        <div
          class="row"
          style="margin-right: 0;"
        >
        <div
            class="col-lg-7"
            style="padding-left: 7%; padding-right: 4%; padding-top: 2%; padding-bottom: 3%; background-color: var(--bootstrapgrey);"
          >
            <div
              class="card p-5 mb-3"
              style="text-align: left;"
            >
              <!-- <h2>You have a roster of all your dental professionals</h2> -->
              <h1 style="font-weight: 900; margin-bottom: 12px; font-size: 2rem;">
                You have a roster of all your medical professionals
            </h1>
              <!-- <h4 class="mt-4">You can manage new applicants, screen them, and decide if you want them on your roster or not.</h4> -->
              <!-- <h4 class="mt-4">Every dental professional can be categorized with types (hygienist, front office, etc), tags (Dentrix, Eaglesoft, etc), locations (Brooklyn, the Bronx, etc) and their schedule of availability, so whenever a booking comes in the system has a good idea who would be interested.</h4> -->
              <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 20px;
                margin-bottom: 5px;
              ">
              You can manage new applicants, screen them, and decide if you want them on your roster or not.
            </h2>
            <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 20px;
                margin-bottom: 0px;
              ">
              Every medical professional can be categorized with types (hygienist, front office, etc), tags (Dentrix, Eaglesoft, etc), locations (Brooklyn, the Bronx, etc) and their schedule of availability, so whenever a booking comes in the system has a good idea who would be interested.
            </h2>
              <!-- <h5 class="mt-4">You'll even be notified if an important document is expiring!</h5> -->
            </div>
          </div>
          <div
            class="col-lg-5 "
            style="margin-right: 0; padding: 0;"
          >
            <div class="dashboardimage">

            </div>
          </div>
        </div>
      </div>

      <div class="mobile-only">
        <div
          class=""
          style="padding-left: 7%; padding-right: 7%; padding-top: 50px; padding-bottom: 5%;"
        >
          <!-- <h2>
            You have a roster of all your dental professionals
          </h2> -->
          <h1 style="font-weight: 900; margin-bottom: 12px; font-size: 2rem;">
            You have a roster of all your medical professionals
            </h1>
          <!-- <h4 class="mt-4" style="line-height: 1.3;">You can manage new applicants, screen them, and decide if you want them on your roster or not.</h4> -->
          <!-- <h4 class="mt-4" style="line-height: 1.3;">Every dental professional can be categorized with types (hygienist, front office, etc), tags (Dentrix, Eaglesoft, etc), locations (Brooklyn, the Bronx, etc) and their schedule of availability, so whenever a booking comes in the system has a good idea who would be interested.</h4> -->
          <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 25px;
                margin-bottom: 25px;
              ">
              You can manage new applicants, screen them, and decide if you want them on your roster or not.
            </h2>
            <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 25px;
                margin-bottom: 25px;
              ">
              Every medical professional can be categorized with types (hygienist, front office, etc), tags (Dentrix, Eaglesoft, etc), locations (Brooklyn, the Bronx, etc) and their schedule of availability, so whenever a booking comes in the system has a good idea who would be interested.
            </h2>
          <!-- <h4 class="mt-4" style="line-height: 1.3;">You'll even be notified if an important document is expiring!</h4> -->
        </div>
        <img src="../assets/img/mobileapp/dental candidate dashboard.png" alt="" style="width: 100%;">
      </div>

      <div
        class="web-only center px-2 mb-5"
        style="
          background-color: var(--coredarkcolor);
          margin-top: 0px;
          margin-bottom: 0px;
          padding-top: 60px;
          padding-bottom: 70px;
        "
      >
        <h5 style="color: white; margin-bottom: 35px">
          <em>Want to learn more and see how it works?</em>
        </h5>
        <div class="mt-3">
          <!-- <router-link
            :to="{ name: 'Demo Video' }"
            class="mylisting-button light-button mx-1"
            target="_blank"
          >Watch the 3 Minute Demo</router-link> -->
          <router-link
            :to="{ name: 'Book App Demo' }"
            class="mylisting-button light-button mx-1"
          >Let's Talk!</router-link>
        </div>
        <!-- <h5 style="color: white; margin-top: 44px">
          <em>Are you a new agency? Ask about our startup pricing!</em>
        </h5> -->
      </div>

      <div
        class="mobile-only center px-2"
        style="
          background-color: var(--coredarkcolor);
          margin-top: 0px;
          margin-bottom: 0px;
          padding-top: 60px;
          padding-bottom: 70px;
        "
      >
        <h5 style="color: white; margin-bottom: 30px">
          <em>Want to learn more?</em>
        </h5>
        <div class="mt-3">
          <!-- <router-link
            :to="{ name: 'Demo Video' }"
            class="mylisting-button light-button mx-1"
            target="_blank"
          >Watch the 3 Minute Demo</router-link> -->
          <router-link
            :to="{ name: 'Book Demo Portfolio Manager' }"
            class="mylisting-button light-button mx-1"
          >Let's Talk!</router-link>
        </div>
      </div>

      <div class="web-only landing">
        <div
          class="row web-only"
          style="
            color: #1f4e78;
            padding-top: 30px;
            padding-bottom: 60px;
            padding-left: 7%;
            padding-right: 7%;
            width: 100%;
            background-color: white;
            margin-left: 0;
          "
        >
          <div class="col-lg-9 col-md-9" style="margin-top: auto; margin-bottom: auto;">
            <!-- <h1 style="font-weight: 900; margin-bottom: 8px;">The software platform</h1> -->
            <h1 style="font-weight: 900; margin-bottom: 12px; font-size: 2rem;">
              Your team is notified of new available bookings
            </h1>
            <!-- <div class="web-only">
              <h3 style="margin-bottom: 4px;">Run your agency smarter with a software solution designed just for you. Your clients and candidates will love it.</h3>
            </div> -->
            <!-- <p style="font-size: 1.25rem; margin-top: 15px; margin-bottom: 2px;">Custom application forms, scheduling, payments, documents, email+SMS automation, beautiful candidate profiles, powerful client dashboards, jobs, bookings, video, interviews, references, analytics - all in one.</p> -->
            <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 25px;
                margin-bottom: 25px;
              ">
              They can see all the details: time, location, requirements and more, whatever you choose. They can let you know if they are interested or not, or even accept the request directly if you want!
            </h2>
          </div>
          <div
            class="col-lg-3 col-md-3 web-only px-3"
            style=""
          >
            <img
              src="../assets/img/mobileapp/available jobs dental.svg"
              width="100%"
              height=""
              class=""
            />
          </div>
        </div>
      </div>

      <div class="mobile-only landing">
        <div
          class="row"
          style="
            color: #1f4e78;
            padding-top: 50px;
            padding-bottom: 60px;
            padding-left: 7%;
            padding-right: 7%;
            width: 100%;
            background-color: white;
            margin-left: 0;
          "
        >
          <div class="col-lg-9 col-md-9" style="margin-top: auto; margin-bottom: auto;">
            <!-- <h1 style="font-weight: 900; margin-bottom: 8px;">The software platform</h1> -->
            <h1 style="font-weight: 900; margin-bottom: 12px; font-size: 2rem;">
                Your team is notified of new available bookings
            </h1>
            <!-- <div class="web-only">
              <h3 style="margin-bottom: 4px;">Run your agency smarter with a software solution designed just for you. Your clients and candidates will love it.</h3>
            </div> -->
            <!-- <p style="font-size: 1.25rem; margin-top: 15px; margin-bottom: 2px;">Custom application forms, scheduling, payments, documents, email+SMS automation, beautiful candidate profiles, powerful client dashboards, jobs, bookings, video, interviews, references, analytics - all in one.</p> -->
            <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 25px;
                margin-bottom: 25px;
              ">
              They can see all the details: time, location, requirements and more, whatever you choose. They can let you know if they are interested or not, or even accept the request directly if you want!
            </h2>
          </div>
          <div
            class="col-lg-3 col-md-3 px-3"
            style=""
          >
            <img
              src="../assets/img/mobileapp/available jobs dental.svg"
              width="100%"
              height=""
              class="mt-2"
            />
          </div>
        </div>
      </div>

      <div class="web-only landing">
        <div
          class="row web-only"
          style="
            color: #1f4e78;
            padding-top: 30px;
            padding-bottom: 60px;
            padding-left: 7%;
            padding-right: 7%;
            width: 100%;
            background-color: white;
            margin-left: 0;
          "
        >
          <div
            class="col-lg-3 col-md-3 web-only px-3"
            style=""
          >
            <img
              src="../assets/img/mobileapp/clock reviews.svg"
              width="100%"
              height=""
              class=""
            />
          </div>
          <div class="col-lg-9 col-md-9 px-4" style="margin-top: auto; margin-bottom: auto;">
            <!-- <h1 style="font-weight: 900; margin-bottom: 8px;">The software platform</h1> -->
            <h1 style="font-weight: 900; margin-bottom: 12px; font-size: 2rem;">
              Your team is matched with jobs
            </h1>
            <!-- <div class="web-only">
              <h3 style="margin-bottom: 4px;">Run your agency smarter with a software solution designed just for you. Your clients and candidates will love it.</h3>
            </div> -->
            <!-- <p style="font-size: 1.25rem; margin-top: 15px; margin-bottom: 2px;">Custom application forms, scheduling, payments, documents, email+SMS automation, beautiful candidate profiles, powerful client dashboards, jobs, bookings, video, interviews, references, analytics - all in one.</p> -->
            <!-- <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 25px;
                margin-bottom: 25px;
              ">
              <span style="font-weight: 900;">They can chat with clients through the app,</span> if you want, which you can monitor!
            </h2> -->
            <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 25px;
                margin-bottom: 25px;
              ">
              They can <span style="font-weight: 900;">clock in and out</span> and <span style="font-weight: 900;">log breaks</span> so you know their hours worked and the system will also <span style="font-weight: 900;">generate reports</span> for you, everything you need for <span style="font-weight: 900;">accounting and payroll.</span> You can also <span style="font-weight: 900;">automate all billing</span> based on per booking fees, hours worked, etc.
            </h2>
            <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 25px;
                margin-bottom: 25px;
              ">
              Both sides can <span style="font-weight: 900;">leave reviews</span> for each other (which you can keep 100% private) so you know who's doing well and who's not.
            </h2>
          </div>
        </div>
      </div>

      <div class="mobile-only landing">
        <div
          class="row"
          style="
            color: #1f4e78;
            padding-top: 30px;
            padding-bottom: 60px;
            padding-left: 7%;
            padding-right: 7%;
            width: 100%;
            background-color: white;
            margin-left: 0;
          "
        >
          <div class="col-lg-9 col-md-9 px-4" style="margin-top: auto; margin-bottom: auto;">
            <!-- <h1 style="font-weight: 900; margin-bottom: 8px;">The software platform</h1> -->
            <h1 style="font-weight: 900; margin-bottom: 12px; font-size: 2rem;">
                Your team is matched with jobs
            </h1>
            <!-- <div class="web-only">
              <h3 style="margin-bottom: 4px;">Run your agency smarter with a software solution designed just for you. Your clients and candidates will love it.</h3>
            </div> -->
            <!-- <p style="font-size: 1.25rem; margin-top: 15px; margin-bottom: 2px;">Custom application forms, scheduling, payments, documents, email+SMS automation, beautiful candidate profiles, powerful client dashboards, jobs, bookings, video, interviews, references, analytics - all in one.</p> -->
            <!-- <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 25px;
                margin-bottom: 25px;
              ">
              <span style="font-weight: 900;">Caregivers and clients can chat through the app,</span> which you can monitor!
            </h2> -->
            <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 25px;
                margin-bottom: 25px;
              ">
              They can <span style="font-weight: 900;">clock in and out</span> and <span style="font-weight: 900;">log breaks</span> so you know their hours worked and the system will also <span style="font-weight: 900;">generate reports</span> for you, everything you need for <span style="font-weight: 900;">accounting and payroll.</span> You can also <span style="font-weight: 900;">automate all billing</span> based on per booking fees, hours worked, etc.
            </h2>
            <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 25px;
                margin-bottom: 25px;
              ">
              Both sides can <span style="font-weight: 900;">leave reviews</span> for each other (which you can keep 100% private) so you know who's doing well and who's not.
            </h2>
          </div>
          <div
            class="col-lg-3 col-md-3 px-3"
            style=""
          >
            <img
              src="../assets/img/mobileapp/clock reviews.svg"
              width="100%"
              height=""
              class=""
            />
          </div>
        </div>
      </div>

      <div
        class="web-only center px-2 mb-5"
        style="
          background-color: var(--coredarkcolor);
          color: white;
          margin-top: 30px;
          margin-bottom: 0px;
          padding-top: 60px;
          padding-bottom: 70px;
        "
      >
        <h4 style="font-weight: 800; margin-bottom: 25px;">
          Your app is truly your app, 100% custom branded
        </h4>
        <!-- <h5 style="color: white; margin-bottom: 35px; line-height: 1.5;">
          So many parents go to the App Store and Play store and search "Nanny" or "Sitter" <br>and your agency will start to come up! It's an awesome discovery channel.
        </h5> -->
        <img
          src="../assets/img/mobileapp/app stores2 dental.svg"
          width="100%"
          height=""
          class="mb-4"
          style="max-width: 400px;"
        />
        <div class="mt-3">
          <!-- <router-link
            :to="{ name: 'Demo Video' }"
            class="mylisting-button light-button mx-1"
            target="_blank"
          >Watch the 3 Minute Demo</router-link> -->
          <router-link
            :to="{ name: 'Book App Demo' }"
            class="mylisting-button light-button mx-1"
          >Let's Talk!</router-link>
        </div>
        <!-- <h5 style="color: white; margin-top: 44px">
          <em>Are you a new agency? Ask about our startup pricing!</em>
        </h5> -->
      </div>

      <div
        class="mobile-only center px-2 mb-5"
        style="
          background-color: var(--coredarkcolor);
          color: white;
          margin-top: 30px;
          margin-bottom: 0px;
          padding-top: 60px;
          padding-bottom: 80px;
        "
      >
        <h4 style="font-weight: 800; margin-bottom: 25px;" class="px-4">
          Your app is truly your app, 100% custom branded
        </h4>
        <!-- <h5 style="color: white; margin-bottom: 35px; line-height: 1.5;" class="px-3">
          So many parents go to the App Store and Play store and search "Nanny" or "Sitter" and your agency will start to come up! It's an awesome discovery channel.
        </h5> -->
        <img
          src="../assets/img/mobileapp/app stores2 dental.svg"
          width="100%"
          height=""
          class="px-3"
          style="max-width: 400px; margin-bottom: 40px;"
        />
        <div class="mt-3">
          <!-- <router-link
            :to="{ name: 'Demo Video' }"
            class="mylisting-button light-button mx-1"
            target="_blank"
          >Watch the 3 Minute Demo</router-link> -->
          <router-link
            :to="{ name: 'Book App Demo' }"
            class="mylisting-button light-button mx-1"
          >Let's Talk!</router-link>
        </div>
        <!-- <h5 style="color: white; margin-top: 44px">
          <em>Are you a new agency? Ask about our startup pricing!</em>
        </h5> -->
      </div>

      <div class="web-only center" style="margin-top: 75px;">
        <h4 class="" style="margin-bottom: 40px;">Do you do <span style="font-weight: 900;">long term, full/part-time placements</span>? The system also takes care of that!</h4>
        <!-- <div class="row" style="padding-left: 7%; padding-right: 7%; --bs-gutter-x: 0;"> -->
          <!-- <div class="col-lg-6">
            <img
              src="../assets/img/home/icons/userprofiles3.1.svg"
              alt=""
              class="association-logo mx-3"
              style="margin-bottom: 20px;"
            >
            <h5 class="px-3" style="line-height: 1.4; margin-bottom: 30px;">Custom, multimedia nanny portfolios with intro videos</h5>
            <a class="mylisting-button dark-button" href="https://myportfolio.enginehire.io/candidates/KPMxBg2oVL1WAQwy" target="_blank">Check Out An Example</a>
          </div>
          <div class="col-lg-6">
            <img
              src="../assets/img/home/icons/briefcase.svg"
              alt=""
              class="association-logo mx-3"
              style="margin-bottom: 20px;"
            >
            <h5 class="px-3" style="line-height: 1.4; margin-bottom: 30px;">Picture perfect job postings and a job board on your website</h5>
            <a class="mylisting-button dark-button" href="https://www.pinknannies.com/job-board" target="_blank">Check Out An Example</a>
          </div> -->
          <!-- <div class="col-lg-4">
            <img
              src="../assets/img/home/icons/blogwriting.svg"
              alt=""
              class="association-logo mx-3"
              style="margin-bottom: 20px;"
            >
            <h5 class="px-3" style="line-height: 1.4; margin-bottom: 30px;">Beautiful presentations of nanny matches to clients</h5>
            <a class="mylisting-button dark-button" href="https://myportfolio.enginehire.io/candidates/KPMxBg2oVL1WAQwy" target="_blank" style="">Check Out An Example</a>
          </div> -->
        <!-- </div> -->
        <!-- <h4 class="" style="margin-top: 70px; margin-bottom: 75px;">You can even super search: "I need a nanny within 10 miles who speaks Spanish & likes dogs"</h4> -->
        <!-- <hr> -->
      </div>

      <div class="mobile-only center px-3" style="margin-top: 55px;">
        <h4 class="px-3" style="margin-bottom: 0px;">Do you do <span style="font-weight: 900;">long term, full/part-time placements</span>? The system also takes care of that!</h4>
        <!-- <div class="row" style="padding-left: 7%; padding-right: 7%; --bs-gutter-x: 0;"> -->
          <!-- <div class="col-lg-4" style="margin-bottom: 60px;">
            <img
              src="../assets/img/home/icons/userprofiles3.1.svg"
              alt=""
              class="association-logo mx-3"
              style="margin-bottom: 20px;"
            >
            <h5 class="px-3" style="line-height: 1.4; margin-bottom: 30px;">Custom, multimedia nanny portfolios with intro videos</h5>
            <a class="mylisting-button dark-button" href="https://myportfolio.enginehire.io/candidates/KPMxBg2oVL1WAQwy" target="_blank">Check Out An Example</a>
          </div>
          <div class="col-lg-4" style="margin-bottom: 60px;">
            <img
              src="../assets/img/home/icons/briefcase.svg"
              alt=""
              class="association-logo mx-3"
              style="margin-bottom: 20px;"
            >
            <h5 class="px-3" style="line-height: 1.4; margin-bottom: 30px;">Picture perfect job postings and a job board on your website</h5>
            <a class="mylisting-button dark-button" href="https://www.pinknannies.com/job-board" target="_blank">Check Out An Example</a>
          </div> -->
          <!-- <div class="col-lg-4" style="margin-bottom: 60px;">
            <img
              src="../assets/img/home/icons/blogwriting.svg"
              alt=""
              class="association-logo mx-3"
              style="margin-bottom: 20px;"
            >
            <h5 class="px-3" style="line-height: 1.4; margin-bottom: 30px;">Beautiful presentations of nanny matches to clients</h5>
            <a class="mylisting-button dark-button" href="https://myportfolio.enginehire.io/candidates/KPMxBg2oVL1WAQwy" target="_blank" style="">Check Out An Example</a>
          </div> -->
        <!-- </div> -->
        <!-- <h4 class="px-2" style="margin-top: 0px; margin-bottom: 75px;">You can even super search: "I need a nanny within 10 miles who speaks Spanish & likes dogs"</h4> -->
        <!-- <hr> -->
      </div>

      <!-- <div class="web-only center" style="padding-left: 7%; padding-right: 7%; padding-top: 4%; padding-bottom: 6%; background-color: var(--bootstrapgrey);">
        <div class="card p-5">
        <h4 class="" style="margin-bottom: 40px;">That's not all! We are adding <span style="font-weight: 900;">new functionality</span> for you <span style="font-weight: 900;">every single day.</span> You can even:</h4>
        <div class="row" style="padding-left: 7%; padding-right: 7%; --bs-gutter-x: 0;">
          <div class="col-lg-6">
            <img
              src="../assets/img/home/icons/creditcards.svg"
              alt=""
              class="association-logo mx-3"
              style="margin-bottom: 20px;"
            >
            <h5 class="px-3" style="line-height: 1.4; font-weight: 800; margin-bottom: 10px;">Sell Gift Cards</h5>
            <h5 class="px-3" style="line-height: 1.4; margin-bottom: 30px;">Sell directly from your website and through your app, it's the perfect gift and an awesome way to build your business!</h5>
            <a class="mylisting-button dark-button" href="https://staffing.enginehire.io/how-to-sell-gift-cards" target="_blank">Learn More</a>
          </div>
          <div class="col-lg-6">
            <img
              src="../assets/img/home/icons/calendar.svg"
              alt=""
              class="association-logo mx-3"
              style="margin-bottom: 20px;"
            >
            <h5 class="px-3" style="line-height: 1.4; font-weight: 800; margin-bottom: 10px;">Manage Event Childcare</h5>
            <h5 class="px-3" style="line-height: 1.4; margin-bottom: 30px;">Do you manage childcare at weddings or corporate events, or want to? We have a complete system just for that!</h5>
            <a class="mylisting-button dark-button" href="https://staffing.enginehire.io/event-childcare-management-software" target="_blank">Learn More</a>
          </div>
        </div>
        <h4 class="" style="margin-top: 70px; margin-bottom: 25px;">You'll also join the Enginehire <span style="font-weight: 900;">community</span> with hundred of amazing agency owners - ask questions, share ideas, learn and grow! We have amazing <span style="font-weight: 900;">sessions and webinars</span> for you every single week.</h4>
        </div>
      </div> -->

      <!-- <div class="mobile-only center" style="padding-left: 7%; padding-right: 7%; padding-top: 6%; padding-bottom: 7%; background-color: var(--bootstrapgrey);">
        <div class="card" style="padding: 10%;">
        <h4 class="" style="margin-bottom: 40px;">That's not all! We are adding <span style="font-weight: 900;">new functionality</span> for you <span style="font-weight: 900;">every single day.</span> You can even:</h4>
        <img
            src="../assets/img/home/icons/creditcards.svg"
            alt=""
            class="association-logo mx-3"
            style="margin-bottom: 20px;"
        >
        <h5 class="px-3" style="line-height: 1.4; font-weight: 800; margin-bottom: 10px;">Sell Gift Cards</h5>
        <h5 class="px-3" style="line-height: 1.4; margin-bottom: 15px;">Sell directly from your website and through your app, it's the perfect gift and an awesome way to build your business!</h5>
        <a class="mylisting-button dark-button" href="https://staffing.enginehire.io/how-to-sell-gift-cards" target="_blank">Learn More</a>
        <img
            src="../assets/img/home/icons/calendar.svg"
            alt=""
            class="association-logo mx-3"
            style="margin-bottom: 20px; margin-top: 50px;"
        >
        <h5 class="px-3" style="line-height: 1.4; font-weight: 800; margin-bottom: 10px;">Manage Event Childcare</h5>
        <h5 class="px-3" style="line-height: 1.4; margin-bottom: 15px;">Do you manage childcare at weddings or corporate events, or want to? We have a complete system just for that!</h5>
        <a class="mylisting-button dark-button" href="https://staffing.enginehire.io/event-childcare-management-software" target="_blank">Learn More</a>
        <h4 class="" style="margin-top: 60px; margin-bottom: 25px;">You'll also join the Enginehire <span style="font-weight: 900;">community</span> with hundred of amazing agency owners - ask questions, share ideas, learn and grow! We have amazing <span style="font-weight: 900;">sessions and webinars</span> for you every single week.</h4>
        </div>
      </div> -->

      <div
        class="web-only"
        style="padding-left: 7%; padding-right: 7%; margin-top: 75px;"
      >
        <h4 class="center">Discover why hundreds of agencies love and trust Enginehire</h4>
        <h5 class="center">We can easily transfer your information from any existing system and integrate with any website! </h5>
        <h5 class="center">Our team works with you every step of the way to make sure your system is set up exactly how you need it.</h5>
        <!-- <div
          class="mb-5 big-carousel"
          style="margin-top: 25px"
        >
          <CarouselComponent
            :listItems="listTestimonial"
            :itemPerPage="3"
          />
        </div>
        <div
          class="mb-5 medium-carousel"
          style="margin-top: 75px"
        >
          <CarouselComponent
            :listItems="listTestimonial"
            :itemPerPage="2"
          />
        </div> -->
      </div>
  
      <!-- <div class="center web-only mt-5">
        <a
              href="https://www.google.com/search?authuser=1&q=Enginehire&stick=H4sIAAAAAAAAAONgU1IxqDAxTUxMTjaySDNMMTEzSTO1MqgwMzZKTjEwS0tJBTLSTBexcrnmpWfmpWZkFqUCAOL_WSk1AAAA&mat=CWuSl5VloDTK&ved=2ahUKEwjX45yUmqiAAxW_mYkEHQPkAuUQrMcEegQIDRAH#lrd=0x45aacc28f1d464f5:0x632cd06fde32cf5,1,,,,"
              target="_blank"
            >
              <img
                src="../assets/img/home/landing/googlereviews2.jpg"
                alt=""
                class="association-logo mx-3"
              >
            </a>
            <a
              href="https://www.g2.com/products/enginehire/reviews"
              target="_blank"
            >
              <img
                src="../assets/img/home/landing/G2reviews.png"
                alt=""
                class="association-logo mx-3"
              >
            </a>
      </div> -->
  
      <!-- <div
        class="web-only"
        style="padding-left: 7%; padding-right: 7%"
      >
        <div
          class="row"
          style="max-width: 920px; margin-left: auto; margin-right: auto; margin-top: 40px;"
        >
          <div
            class="col customer-logo-container"
            v-for="(agency, index) of listAgencies"
            :key="'agency-' + index"
          >
            <a
              :href="agency.url"
              target="_blank"
            >
              <img
                :src="require(`../assets/img/home/customer_logos/dental/${agency.logo}`)"
                width=""
                height=""
                :alt="agency.alt"
                class="customer-logo"
              />
            </a>
          </div>
        </div>
      </div> -->
  
      <div
        class="mobile-only"
        style="
          padding-top: 50px;
          padding-bottom: 0px;
          padding-left: 2%;
          padding-right: 2%;
        "
      >
        <h4 class="center px-3 mb-3" style="line-height: 1.4;">Discover why hundreds of agencies love and trust Enginehire</h4>
        <h5 class="center px-3 mb-4" style="line-height: 1.4;">We can easily transfer your information from any existing system and integrate with any website! Our team works with you every step of the way to make sure your system is set up exactly how you need it.</h5>
        <!-- <div class="small-carousel">
          <CarouselComponent
            :listItems="listTestimonial"
            :itemPerPage="1"
          />
        </div>
        <div class="tiny-carousel">
          <CarouselComponent
            :listItems="listTestimonial"
            :itemPerPage="1"
            :navigationEnabled="false"
          />
        </div> -->
  
        <!-- <div class="center pt-4">
        <a
              href="https://www.google.com/search?authuser=1&q=Enginehire&stick=H4sIAAAAAAAAAONgU1IxqDAxTUxMTjaySDNMMTEzSTO1MqgwMzZKTjEwS0tJBTLSTBexcrnmpWfmpWZkFqUCAOL_WSk1AAAA&mat=CWuSl5VloDTK&ved=2ahUKEwjX45yUmqiAAxW_mYkEHQPkAuUQrMcEegQIDRAH#lrd=0x45aacc28f1d464f5:0x632cd06fde32cf5,1,,,,"
              target="_blank"
            >
              <img
                src="../assets/img/home/landing/googlereviews2.jpg"
                alt=""
                class="association-logo mx-1"
              >
            </a>
            <a
              href="https://www.g2.com/products/enginehire/reviews"
              target="_blank"
            >
              <img
                src="../assets/img/home/landing/G2reviews.png"
                alt=""
                class="association-logo mx-1"
              >
            </a>
      </div> -->
  
        <!-- <div class="px-3" style="max-width: 100%;">
          <transition
            name="logo"
            mode="out-in"
          >
            <template v-for="(agency, index) of listAgencies">
              <div
                :key="'agency-mobile-' + index"
                class="customer-logo-container"
                v-if="logoCount === index + 1"
              >
                <a
                  :href="agency.url"
                  target="_blank"
                >
                  <img
                    :src="
                      require(`../assets/img/home/customer_logos/dental/${agency.logo}`)
                    "
                    width=""
                    height=""
                    :alt="agency.alt"
                    class="customer-logo"
                  />
                </a>
              </div>
            </template>
          </transition>
        </div> -->
      </div>
  
      <!-- <div class="web-only mb-5" style="margin-top: 75px;">
        <em
          style=""
          class="center mb-4"
        >We are proud members and sponsors of the</em>
        <div
          class="row"
          style="max-width: 650px; margin-left: auto; margin-right: auto"
        >
          <div class="col association-logo-container">
            <a
              href="https://nanny.org/"
              target="_blank"
            >
              <img
                src="../assets/img/associations/INA-Logo-2022.png"
                alt="INA International Nanny Association"
                class="association-logo"
              >
            </a>
          </div>
          <div class="col association-logo-container">
            <a
              href="https://www.nannyrelieffund.org/"
              target="_blank"
            >
              <img
                src="../assets/img/associations/nanny relief fund.png"
                alt="Nanny Relief Fund"
                class="association-logo"
                style="height: 60px; margin-top: 7px;"
              >
            </a>
          </div>
          <div class="col association-logo-container">
            <a
              href="https://theapna.org/"
              target="_blank"
            >
              <img
                src="../assets/img/associations/APNA wide.png"
                alt="APNA Association of Premier Nanny Agencies"
                class="association-logo"
                style="height: 75px; padding-left: 10px;"
              >
            </a>
          </div>
        </div>
      </div> -->

      <h4 class="center mt-5 mb-3 px-3">Want to learn more? We are excited to meet you. (:</h4>
      <!-- <div style="">
        <p
          style="max-width: 600px; display: block; margin-left: auto; margin-right: auto;"
          class="px-2 mt-4 mb-4"
        >Get a step by step run through of the process a candidate and client would take through your system, and the tools at your disposal to manage and automate everything. See for yourself exactly how some of the companies using Enginehire use it, and why they love it!</p>
      </div> -->
      <div
        class="meetings-iframe-container mb-5 web-only"
        data-src="https://meetings.hubspot.com/falak/enginehire-app-demo?embed=true"
      ></div>
      <div
        class="meetings-iframe-container mobile-only"
        data-src="https://meetings.hubspot.com/falak/enginehire-app-demo?embed=true"
      ></div>
      <!-- https://stackoverflow.com/questions/45047126/how-to-add-external-js-scripts-to-vuejs-components -->
      <script
        type="application/javascript"
        src="https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js"
      ></script>

      <!-- <div class="mobile-only mb-5">
        <em
          style=""
          class="center mb-4"
        >We're proud members & sponsors of the</em>
        <div class="col association-logo-container-mobile">
            <a
              href="https://nanny.org/"
              target="_blank"
            >
              <img
                src="../assets/img/associations/INA-Logo-2022.png"
                alt="INA International Nanny Association"
                class="association-logo"
                style="height: 50px;"
              >
            </a>
          </div>
          <div class="col association-logo-container-mobile">
            <a
              href="https://www.nannyrelieffund.org/"
              target="_blank"
            >
              <img
                src="../assets/img/associations/nanny relief fund.png"
                alt="Nanny Relief Fund"
                class="association-logo"
                style="height: 45px; margin-top: 0px;"
              >
            </a>
          </div>
        <div class="col association-logo-container-mobile">
            <a
                href="https://theapna.org/"
                target="_blank"
            >
                <img
                src="../assets/img/associations/APNA wide.png"
                alt="APNA Association of Premier Nanny Agencies"
                class="association-logo"
                style="height: 55px; padding-left: 0px;"
                >
            </a>
        </div>
      </div> -->
    </div>
  </template>
  
  <script>
  import CarouselComponent from "./CarouselComponent";
  
  export default {
    created() {
      // Scroll the window to top on load
      window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
    },
    components: {
      CarouselComponent,
    },
    // https://stackoverflow.com/questions/49849376/vue-js-triggering-a-method-function-every-x-seconds
    mounted: function () {
      window.setInterval(() => {
        this.incrementLogoCount();
      }, 3000);
    },
    data() {
      return {
        logoCount: 1,
        listTestimonial: [
          {
            text: "<strong>We have used so many platforms.</strong> From iCims to Bullhorn, to trying to create ones ourselves with Zoho, Asana, Monday.com, Trello, and Airtable. <strong>They just did not work for our industry.</strong> Enginhire has created a logical system that is simple to use with lots of amazing features. I am so glad we found them.",
            img: {
              src: "Ruka.png",
              alt: "Ruka Curate Tiny Treasures NYC Staffing Agency",
            },
            personInfo: "Ruka C - Co-Founder of",
            link: {
              text: "Tiny Treasures NYC",
              url: "https://www.tinytreasuresnyc.com/",
            },
          },
          // {
          //   text: "As an agency our previous experiences with other software has been less than ideal, but Enginehire has been an absolute breath of fresh air. They are <strong>loyal, reliable, and extremely quick to respond</strong> when an issue arises. They have consistently strived for the <strong>most innovative and user friendly solutions to optimize our business</strong>.",
          //   img: {
          //     src: "caroline.jpg",
          //     alt: "Caroline",
          //   },
          //   personInfo: "Caroline W - Co-founder of",
          //   link: {
          //     text: "Trusting Connections",
          //     url: "https://www.trustingconnections.com/",
          //   },
          // },
          {
            text: "When I first spoke with Enginehire I thought the price was a little steep and almost did not move forward. Ever since then <strong>the price is worth every penny.</strong> If I ever need anything updated, <strong>they respond almost immediately</strong> with a solution. They are continuously working to keep the system updated and <strong>always adding new features</strong>!",
            img: {
              src: "SarahM.png",
              alt: "Sarah Meadors Nannies Coast to Coast Staffing Agency",
            },
            personInfo: "Sarah M - Founder of",
            link: {
              text: "Nannies Coast to Coast",
              url: "https://nanniescoasttocoast.com/",
            },
          },
          {
            text: "<strong>BEST software you will find in the market for NANNY AGENCIES!</strong> The automation of the system saves so much time and the way <strong>you just need to use one software instead of having 10 software for different things.</strong> Also, they are very accommodating to your needs.",
            img: {
              src: "Alejandra.png",
              alt: "Alejandra La Lune Sitters Agency",
            },
            personInfo: "Alejandra D - Owner of",
            link: {
              text: "La Lune Sitters",
              url: "https://www.lalunesitters.com/",
            },
          },
          {
            text: "The Enginehire team was absolutely <strong>wonderful to work with; professional, dedicated, and supportive</strong>. I cannot recommend Enginehire enough if you're looking for a way to <strong>streamline your processes</strong> and work with a patient and understanding team.",
            img: {
              src: "deniz.jpg",
              alt: "Deniz Hanson Trusted Nanny Match Staffing Agency",
            },
            personInfo: "Deniz H - Founder of",
            link: {
              text: "Trusted Nanny Match",
              url: "https://www.trustednannymatch.com/",
            },
          },
          {
            text: "The Enginehire Team have been excellent to work with and provide <strong>phenomenal customer service</strong>. Their <strong>knowledge of the industry and individual customization is unparalleled</strong> and their platform has revolutionized the way that my team does business.",
            img: {
              src: "lydia.jpg",
              alt: "Lydia Sommet Nannies Staffing Agency",
            },
            personInfo: "Lydia B - Owner of",
            link: {
              text: "Sommet Nannies",
              url: "https://www.sommetnannies.com/",
            },
          },
          {
            text: "I should have done this months ago. <strong>I waited out of fear and concern that automation wouldn't be the right fit for such a personalized service. I was so wrong</strong> and I'm kicking my past self for waiting! Any agency that is on the fence or considering Enginehire should just take the plunge. It is worth every penny!",
            img: {
              src: "ameliaG2.png",
              alt: "Amelia Nannies Agency",
            },
            personInfo: "Amelia D - Owner of",
            link: {
              text: "Amelia's Nannies",
              url: "https://www.ameliasnannies.com/",
            },
          },
          {
            text: "I have used two other management platforms and I can tell you that Enginehire is the best. Want a one-stop shop? You can match people to jobs, build resumes directly from their profiles, and so much more in seconds. <strong>Enginehire has saved me money by saving me time.</strong>",
            img: {
              src: "debra.jpg",
              alt: "Debra Elite Family Care Staffing Agency",
            },
            personInfo: "Debra F - Owner of",
            link: {
              text: "Elite Family Care",
              url: "https://elitefamilycare.com/",
            },
          },
          {
            text: "<strong>I consulted with Enginehire before my agency was even officially launched.</strong> They helped me greatly by providing me with an internal and external-facing system for candidates to apply on my site. Most agency owners I speak with either use Enginehire currently or they are making the switch over to Enginehire from another platform.",
            img: {
              src: "alison_myhouseholdmanaged.png",
              alt: "Alison My Household Managed Staffing Agency",
            },
            personInfo: "Alison G - Owner of",
            link: {
              text: "My Household Managed",
              url: "https://myhouseholdmanaged.com/",
            },
          },
        ],
        listAgencies: [
          {
            url: "https://www.dentalplacementservice.com/",
            logo: "dental_personnel_placement_service.jpg",
            alt: "Dental Personnel Placement Service",
          },
          {
            url: "https://dentalplacements.net/",
            logo: "professional_dental_placements.png",
            alt: "Professional Dental Placements",
          },
          {
            url: "https://www.dental-directions.com",
            logo: "dental directions.png",
            alt: "Dental Directions",
          },
          {
            url: "https://www.larkinagencystaffing.com",
            logo: "larkin.png",
            alt: "Larkin Healthcare Recruiting Agency Staffing",
          },
          {
            url: "https://www.smiledentaltempsllcnj.com",
            logo: "smile dental temps.png",
            alt: "Smile Dental Temps",
          },
          {
            url: "https://dentalforcetx.com/",
            logo: "dental force.png",
            alt: "Dental Force Tx",
          },
          
          {
            url: "https://dentalforcetx.com/",
            logo: "dental partners.jpg",
            alt: "Dental Partners LLC",
          },
        //   {
        //     url: "https://dentalforcetx.com/",
        //     logo: "dental force.png",
        //     alt: "Dental Force Tx",
        //   },
        ],
        listFeatures: [
        {
            icon: "beautifulwebsite.svg",
            title: "Web Forms",
            text: "Custom inquiry forms, embedded directly into your website",
            alt: "Nanny Staffing Agency Website"
          },
          {
            icon: "calendar.svg",
            title: "Scheduling",
            text: "Easily book meetings and consultations, no more “when are you free?” emails",
            alt: "Staffing Agency Meeting Scheduling"
          },
          {
            icon: "document.svg",
            title: "Signatures",
            text: "Built in documents and e-signatures - no need for PDFs or DocuSign",
            alt: ""
          },
        {
            icon: "booksapple_blue.svg",
            title: "Classes",
            text: "Offer classes, courses and training, easily bookable through your website",
            alt: "Nanny Agency App"
          },
          
        //   {
        //     icon: "briefcase.svg",
        //     title: "Beautiful Job Postings",
        //     text: "Seamlessly collect applications and attract the best candidates",
        //     alt: "Nanny Staffing Agency Job Board"
        //   },
        //   {
        //     icon: "phonetracking.svg",
        //     title: "Shift Management",
        //     text: "Manage schedules and fill short term placements in seconds",
        //     alt: "Pro Sitter App"
        //   },
          {
            icon: "SMS.svg",
            title: "Auto Email+SMS",
            text: "Spend time actually talking to people - no more rewriting the same thing",
            alt: "Staffing Agency Text Messaging"
          },
          
          {
            icon: "creditcards.svg",
            title: "Payments",
            text: "Built in payment processing - no more chasing clients to pay invoices",
            alt: "Stripe Quickbooks Payment Processing"
          },
          {
            icon: "blogwriting.svg",
            title: "Notes",
            text: "Consultation calls, meetings, etc. - take all your notes, all in one place",
            alt: "Staffing Agency Reference Checking"
          },
          {
            icon: "analytics.svg",
            title: "Analytics",
            text: "Understand what’s working, what’s not, and how to grow your business further",
            alt: "Staffing Agency Analytics"
          },
        ],
      };
    },
    methods: {
      incrementLogoCount() {
        if (this.logoCount == this.listAgencies.length) {
          this.logoCount = 1;
        } else {
          this.logoCount += 1;
        }
      },
    },
  };
  </script>
  
  <style>
  .landing {
    /* height: 100vh; */
    /* background-color: var(--skyblue); */
    /* background-color: var(--coredarkcolor); */
    /* background-color: #fcbf67; */
    width: 100%;
  
    /* height: 75vh; */
    /* height: 70vh; */
    /* min-height: 550px; */
    /* padding-left: 5%; */
    /* padding-right: 5%; */
  
    /* background-color: white;
    background: url("../assets/img/home/landing/AdobeStock_161673435_shaded6.1_compressed.png")
      left center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    background-repeat: no-repeat; */
  
    /* background-position: left top; */
  }

  .dashboardimage {
    /* height: 100vh; */
    /* background-color: var(--skyblue); */
    background-color: var(--coredarkcolor);
    /* background-color: #fcbf67; */
    width: 100%;
  
    /* height: 75vh; */
    /* height: 70vh; */
    height: 100%;
    /* min-height: 550px; */
    /* padding-left: 5%; */
    /* padding-right: 5%; */
  
    background-color: white;
    background: url("../assets/img/newborn/client_dashboard.png") left
      bottom;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .mapimage {
    /* height: 100vh; */
    /* background-color: var(--skyblue); */
    background-color: var(--coredarkcolor);
    /* background-color: #fcbf67; */
    width: 100%;
  
    /* height: 75vh; */
    /* height: 70vh; */
    height: 100%;
    /* min-height: 550px; */
    /* padding-left: 5%; */
    /* padding-right: 5%; */
  
    background-color: white;
    background: url("../assets/img/newborn/master_calendar crop.png") center
      bottom;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .dashboardimage {
    /* height: 100vh; */
    /* background-color: var(--skyblue); */
    background-color: var(--coredarkcolor);
    /* background-color: #fcbf67; */
    width: 100%;
  
    /* height: 75vh; */
    /* height: 70vh; */
    height: 100%;
    /* min-height: 550px; */
    /* padding-left: 5%; */
    /* padding-right: 5%; */
  
    background-color: white;
    background: url("../assets/img/mobileapp/dental candidate dashboard.png") left
      bottom;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    background-repeat: no-repeat;
  }
  
  .momimage {
    /* height: 100vh; */
    /* background-color: var(--skyblue); */
    background-color: var(--coredarkcolor);
    /* background-color: #fcbf67; */
    width: 100%;
  
    /* height: 75vh; */
    /* height: 70vh; */
    min-height: 550px;
    /* padding-left: 5%; */
    /* padding-right: 5%; */
  
    background-color: white;
    background: url("../assets/img/home/landing/AdobeStock_392855683.jpg") left
      center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    background-repeat: no-repeat;
  }
  
  .seniorimage {
    /* height: 100vh; */
    /* background-color: var(--skyblue); */
    background-color: var(--coredarkcolor);
    /* background-color: #fcbf67; */
    width: 100%;
  
    /* height: 75vh; */
    /* height: 70vh; */
    min-height: 550px;
    /* padding-left: 5%; */
    /* padding-right: 5%; */
  
    background-color: white;
    background: url("../assets/img/home/landing/AdobeStock_423398211.jpg") left
      center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    background-repeat: no-repeat;
  }
  
  .mobile-landing {
    /* height: 100vh; */
    /* background-color: var(--shopify); */
    /* background-color: #fcbf67; */
    width: 100%;
  
    /* height: 75vh; */
    /* height: 70vh;  */
    /* min-height: 550px; */
    padding-left: 0;
    padding-right: 0;
  
    /* background-color: var(--coredarkcolor); */
    /* background-image: url('https://thewallpaper.co//wp-content/uploads/2016/10preview/goku-universal-hero-backgrounds-photo-hd-wallpapers-4k-amazing-desktop-wallpapers-mac-desktop-images-widescreen-1080p-digital-photos-1920x1080.jpg'); */
    /* background-image: url('../assets/img/AdobeStock_272829109_Preview2.png'); */
    /* background-image: url('../assets/img/AdobeStock_95578556_Preview_crop1.jpeg'); */
    /* background: url('../assets/img/AdobeStock_95578556_Preview_crop1.jpeg') left center; */
    /* background: url('../assets/img/landing/AdobeStock_95578556_crop1.jpeg') left center; */
    /* background: url('../assets/img/landing/employer/AdobeStock_95578556_crop1_resize1.jpeg') left center; */
    
    /* background: url("../assets/img/home/landing/AdobeStock_161673435_shaded6.1_compressed.png")
      center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    background-repeat: no-repeat; */
  
    /* background-position: left top; */
  }
  
  .customer-logo-container {
    text-align: center;
    display: block;
    margin-left: auto;
    margin-right: auto;
    padding-top: 7px;
    padding-bottom: 38px;
  }
  .customer-logo {
    height: 70px;
    /* max-width: 100px; */
  }
  
  .association-logo-container {
    text-align: center;
    display: block;
    margin-left: auto;
    margin-right: auto;
    padding-top: 7px;
    padding-bottom: 38px;
  }
  .association-logo-container-mobile {
    text-align: center;
    display: block;
    margin-left: auto;
    margin-right: auto;
    padding-top: 7px;
    padding-bottom: 25px;
  }
  .association-logo {
    height: 75px;
    /* max-width: 100px; */
  }
  
  .feature-card {
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 20px;
    padding-right: 20px;
    /* margin-left: 10px; */
    /* margin-right: 10px; */
    /* max-width: 20%; */
    /* width: 99%; */
    /* border: 1px solid gray; */
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    text-align: center;
    margin-left: auto;
    margin-right: auto;
  }
  .card {
    padding-top: 30px;
    padding-bottom: 20px;
    padding-left: 20px;
    padding-right: 20px;
    /* margin-left: 10px; */
    /* margin-right: 10px; */
    /* max-width: 20%; */
    /* width: 99%; */
    /* border: 1px solid gray; */
    /* box-shadow: 0 .25rem 0.5rem rgba(0,0,0,.15); */
    text-align: center;
    margin-top: 25px;
    /* margin-left: auto; */
    /* margin-right: auto; */
  
    border: none;
  }
  .card-body {
    padding: 0.1rem;
  }
  .feature-card img {
    text-align: center;
    display: block;
    margin-left: auto;
    margin-right: auto;
    height: 170px;
  }
  .card img {
    /* text-align: center;
    display: block;
    margin-left: auto;
    margin-right: auto;
    height: 170px; */
  }
  .card-img-top {
    /* text-align: center; */
    display: block;
    margin-left: 0 !important;
    margin-right: auto !important;
    text-align: left;
    float: left;
    height: 70px;
    margin-bottom: 10px;
  }
  .feature-img {
    height: 70px;
    display: block;
    margin-right: auto;
    margin-bottom: 10px;
  }
  .feature-card-title {
    margin-top: 15px;
  }
  .card-title {
    line-height: 1.3;
    text-align: left;
  }
  .card-text {
    text-align: left;
  }
  
  .testimonial-card {
    /* background-color: #eaf4fe; */
  }
  .testimonial-card img {
    /* height: 150px;
    width: 150px;
    border-radius: 50%; */
  }
  
  .customer-image {
    border-radius: 50%;
    width: 150px;
  }
  
  .visit-platform-button {
    margin-top: 33px;
    margin-bottom: 12px;
  }
  
  .logo-enter {
    opacity: 0;
  }
  .logo-enter-active {
    transition: opacity 1s;
  }
  .logo-leave {
  }
  .logo-leave-active {
    transition: opacity 1s;
    opacity: 0;
  }
  
  /* ------------------- SMALL -------------------- */
  @media (max-width: 768px) {
    .card {
      /* margin-top: 20px; */
      margin-top: 2px;
    }
    .card-deck .card {
      margin-bottom: 2px;
    }
  }
  
  .card-image-container {
    text-align: center;
    margin: 1rem 0;
  }
  
  .card-image {
    border-radius: 50%;
    text-align: left;
  }
  
  .medium-carousel {
    display: none;
  }
  .big-carousel {
    display: inherit;
  }
  
  .small-carousel {
    display: inherit;
    margin: 0 40px;
  }
  .tiny-carousel {
    display: none;
  }
  
  .features-summary-section {
    display: flex;
    flex-wrap: wrap;
    margin-top: 5px;
    margin-bottom: 10px;
  }
  
  .feature-container {
    flex-basis: 25%;
    padding-left: 30px;
    padding-right: 30px;
  }
  
  @media (max-width: 1280px) {
    .medium-carousel {
      display: inherit;
    }
    .big-carousel {
      display: none;
    }
    .feature-container {
      flex-basis: 25%;
    }
  }
  
  @media (max-width: 960px) {
    .feature-container {
      flex-basis: 33.33%;
    }
  }
  
  @media (max-width: 768px) {
    .features-summary-section {
      margin-bottom: 10px;
    }
    .feature-container {
      flex-basis: 50%;
    }
  }
  
  @media (max-width: 575px) {
    .feature-container {
      flex-basis: 100%;
    }
  }
  
  @media (max-width: 460px) {
    .small-carousel {
      display: none;
    }
    .tiny-carousel {
      display: inherit;
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/MedicalAgencyApp.vue